export const customAttributeCodes = {
  StullerItem: 'STULLERITEM'
}
